import { useCallback } from "react";
import { useAssessmentSession } from "../../contexts/assessmentUserContext";
import { getApiUrls } from "../apiUrl";
import { postAssessmentAnalyticsEvent } from "../../services/assessmentAnalyticsService";

type UseAssessmentEventerInput = {
  action: string;
  location?: string;
  timestamp?: string;
  data?: Record<string, unknown>;
};

const { assessmentsApiUrl } = getApiUrls();

export function useAssessmentEventer() {
  const { me, token } = useAssessmentSession();
  const userId = me?.id ?? null;

  return useCallback(
    async ({
      action,
      location,
      timestamp,
      data,
    }: UseAssessmentEventerInput): Promise<void> => {
      try {
        await postAssessmentAnalyticsEvent({
          appApiUrl: assessmentsApiUrl,
          token,
          userId,
          action,
          location,
          timestamp,
          data,
        });
      } catch (error: unknown) {
        console.warn("Assessment analytics event failed.", {
          action,
          location,
          error,
        });
      }
    },
    [token, userId],
  );
}
